/* eslint-disable */
import 'nodelist-foreach-polyfill';
import Swiper from 'swiper/dist/js/swiper'; // https://github.com/nolimits4web/Swiper/issues/2263
import 'swiper/dist/css/swiper.css';
import './history-slider.scss';
import scrollSlider from '../../../scroll-slider';
// import throttleWheel from '../../../throttle-wheel';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-history-slider-wrapper]').forEach((wrapper) => {
    const container = wrapper.querySelector('[data-history-slider]');
    const speed = 500;
    const swiper = new Swiper(container, { // eslint-disable-line
      slidesPerView: 1,
      spaceBetween: 120,
      speed,
      pagination: {
        el: '.history-slider-pagination',
        clickable: true
      },
      breakpoints: {
        1100: {
          spaceBetween: 80,
        },
        640: {
          spaceBetween: 20,
        }
      },
      mousewheel: {
        eventsTarged: wrapper,
        forceToAxis: true,
        invert: true,
      },
    });
    // throttleWheel(container, speed);

    //if (!window.isMobile.any) {
    if (false) {
      const setScrolling = scrollSlider(wrapper.closest('[data-scrollmagic]'), {
        length: swiper.slides.length,
        onUpdate: index => swiper.slideTo(index),
        headerOffset: 20,
      })
      swiper.on('slideChange', () => setScrolling(swiper.activeIndex));
    }
  });
});
